import { render } from "./UserList.vue?vue&type=template&id=291a3b0c&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=291a3b0c&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291a3b0c"]])

export default __exports__